/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', function() {
  var chatButtons = document.querySelectorAll('.chat-button');

  chatButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault(); // Stop the link from firing immediately

      // 1. Look for the modern Shopify Inbox element
      var inboxElement = document.querySelector('inbox-online-store-chat');
      
      // 2. Look for the legacy container (just in case)
      var shopifyChat = document.getElementById('shopify-chat');

      // Attempt 1: Modern Shadow DOM (Works in Chrome/Edge)
      if (inboxElement && inboxElement.shadowRoot) {
        var toggleButton = inboxElement.shadowRoot.querySelector('button'); 
        if (toggleButton) {
          toggleButton.click(); // Click the internal button
          return; // STOP here. Do not redirect.
        }
      }

      // Attempt 2: Legacy PostMessage
      if (shopifyChat) {
         shopifyChat.contentWindow.postMessage({ type: 'open_chat' }, '*');
         return; // STOP here. Do not redirect.
      }

      // 3. FAILSAFE (For Firefox/Blocked Users)
      // If we get here, the chat widget was not found or is blocked.
      // Redirect to the contact page so the customer isn't stuck.
      console.log("Chat blocked or missing. Redirecting to contact page.");
      window.location.href = "/pages/contact-us";
    });
  });
});